import React, { useState } from 'react';
import { ShieldAlert } from 'lucide-react';
import Button from './ui/Button';

export default function LoginAgeGateModal() {
  const [open, setOpen] = useState(true);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/90 p-4 backdrop-blur-sm">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-zinc-900 p-8 text-center shadow-2xl">
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-rose-500/15">
          <ShieldAlert className="h-8 w-8 text-rose-400" />
        </div>
        <h2 className="mb-2 text-2xl font-semibold text-white">Verificação de idade</h2>
        <p className="mb-1 text-sm text-zinc-300">Este site contém conteúdo adulto (+18).</p>
        <p className="mb-6 text-sm text-zinc-400">Você confirma que tem 18 anos ou mais?</p>

        <div className="flex gap-3">
          <Button fullWidth onClick={() => setOpen(false)}>
            Tenho 18+ anos
          </Button>
          <Button
            fullWidth
            variant="secondary"
            onClick={() => {
              window.location.href = 'https://google.com';
            }}
          >
            Sair
          </Button>
        </div>

        <p className="mt-5 text-xs text-zinc-500">
          Ao continuar, você declara estar ciente da natureza adulta do conteúdo.
        </p>
      </div>
    </div>
  );
}
